<template>
  <article class="car_info">
    <h2 class="title">选择品牌</h2>
    <ul class="car_brand_abb">
      <li v-for="key in typeList" :key="key" :class="{on: key === keyVal}">
        <a href="javascript:void(0);" @click.stop="selBrand(key)">
          <i class="icon_hot" v-if="key === 'HOT'"></i>
          {{ key }}
        </a>
      </li>
    </ul>
    <ul class="car_brand_detail">
      <li v-for="brand in brandByID" :key="brand.id">
        <a href="javascript:void(0);" class="info" @click.stop="selSeries(brand)">
          <img :src="brand.image_url" alt="" class="logo">
          <span>{{brand.name}}</span>
        </a>
      </li>
    </ul>
  </article>
</template>
<script>
import cache from '../../common/cache'

export default {
  data() {
    return {
      sessionKey: 'carBrands',
      brands: {},
      brandByID: [],
      keyVal: 'HOT',
      typeList: []
      // typeList: ['HOT', 'A', 'B', 'C', 'D', 'F', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'Q', 'R', 'S', 'T', 'W', 'X', 'Y', 'Z']
    }
  },
  created() {
    let brands = cache.getSessionData(this.sessionKey)
    let from = this.$route.query.from
    cache.setSessionData('carModelInfo', from)
    if (brands) {
      this.brands = brands
      this.setTypeList(this.brands)
      this.brandByID = this.brands.HOT
    } else {
      this.$rest.carInfo.getCarBrandList().then((res) => {
        if (res.code === 0) {
          this.brands = res.brands
          this.setTypeList(this.brands)
          cache.setSessionData(this.sessionKey, this.brands)
          this.brandByID = this.brands.HOT
        } else {
          this.showToast(res.message)
        }
      })
    }
  },
  methods: {
    setTypeList(brands) {
      let typeList = Object.keys(brands)
      typeList.forEach((v, i, a) => {
        if (v === 'HOT') { // 保证HOT在第一位
          a.splice(i, 1)
          a.unshift(v)
        }
      })
      this.typeList = typeList
    },
    selBrand(v) {
      this.brandByID = this.brands[v]
      this.keyVal = v
    },
    selSeries(brand) {
      let from = this.$route.query.from
      if (from === '/carRegister/index') {
        // 更新车辆品牌信息
        this.$store.dispatch('UPDATE_CAR_REGISTER_INFO', Object.assign({}, this.$store.state.carRegister.carInfo, {
          brand: brand.name,
          brand_id: brand.id
        }))
        this.$router.push({
          path: from,
          query: { from: '/car/brand' }
        })
        return
      }
      this.$router.push({
        path: '/car/series/' + brand.id
      })
    }
  }
}

</script>
<style scoped lang="less">
@import "../../stylesheets/modules/car/brand.less";
</style>
